import _ from 'underscore';
import Flux from 'lib/flux';
import BookingService from 'services/booking';
import BookingConstants from 'constants/booking';
import { dispatch } from 'lib/exp/flux';

const BookingActionCreator = Flux.createActionCreator({
  decline(params) {
    let onFullfilled;
    let onRejected;
    const _this = this;

    onFullfilled = function (resp) {
      _this.dispatchAction(BookingConstants.REJECT_COMPLETED, resp);
    };

    onRejected = function (errors) {
      _this.dispatchAction(BookingConstants.REJECT_FAILED, errors);
    };

    this.dispatchAction(BookingConstants.REJECT);
    BookingService.decline(_.extend({}, params, { medium: 'Email' })).then(
      onFullfilled,
      onRejected
    );
  },

  accept(params) {
    let onFullfilled;
    let onRejected;
    const _this = this;
    this.dispatchAction(BookingConstants.ACCEPT);

    onFullfilled = function (resp) {
      _this.dispatchAction(BookingConstants.ACCEPT_COMPLETED, resp);
    };

    onRejected = function (errors) {
      _this.dispatchAction(BookingConstants.ACCEPT_FAILED, errors);
    };

    BookingService.accept(_.extend({}, params, { medium: 'Email' })).then(
      onFullfilled,
      onRejected
    );
  },

  invoiceGuest(params) {
    const onCompleted = (resp) => {
      dispatch({ type: 'BOOKING_INVOICE_GUEST_COMPLETED', payload: resp });
    };
    const onRejected = (resp) => {
      dispatch({
        type: 'BOOKING_INVOICE_GUEST_FAILED',
        payload: resp.responseJSON || {},
      });
    };
    dispatch({ type: 'BOOKING_INVOICE_GUEST' });
    BookingService.invoiceGuest(params).then(onCompleted, onRejected);
  },

  invoiceGuestReset() {
    dispatch({ type: 'BOOKING_INVOICE_GUEST_RESET' });
  },
});

export default BookingActionCreator;
